import { pluralize, route } from "@helpers"
import useArchive from "@hooks/useArchive"
import useAuth from "@hooks/useAuth"
import CurrentSalon from "../components/CurrentSalon"

export default function useCurrentArchive(salons?: Resources.CurrentSalon[]) {
    const { user } = useAuth<Resources.Customer>()
    const archive = useArchive(salons)

    archive.useComponent(CurrentSalon)
    archive.useOptions({ idx: true })
    archive.useGrid({ columns: "3" })
    archive.useEmpty({
        heading: "We don't have open salons for you at the moment", 

        description: user.participating_count > 0 
            ? `But you're already participating in ${pluralize(user.participating_count, "salon")}. Visit Entries to see them.`
            : "Please, visit the website in a few weeks to participate in our future salons.",

        button: user.participating_count > 0 
            ? { value: "See Entries", to: route("customer:participating") }
            : undefined
    })

    return archive
}